import { ICreateClienteCentroCustoUseCase } from "../../../presentation/useCases/create/create_cliente_centro_custo_use_case";
import { ClienteCentroCusto } from "../../models/clienteCentroCusto";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * CreateClienteCentroCustoUseCase
 */

export class CreateClienteCentroCustoUseCase implements ICreateClienteCentroCustoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(form: ClienteCentroCusto): Promise<number> {
    return this.repository.createClienteCentroCusto(form);

  }
}
